export default __webpack_public_path__ + "static/media/h1.04d8b355.jpg";